import { render, staticRenderFns } from "./_createCustomContract.vue?vue&type=template&id=7637053f"
import script from "./_createCustomContract.vue?vue&type=script&lang=js"
export * from "./_createCustomContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports